import { render, staticRenderFns } from "./DropdownSection.vue?vue&type=template&id=3598afca&scoped=true&"
import script from "./DropdownSection.vue?vue&type=script&lang=ts&"
export * from "./DropdownSection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3598afca",
  null
  
)

export default component.exports